import { INTEGRATION_PROVIDERS } from "@vy/types";
import { useActivatedIntegration } from "../../../use-activated-integration";

export function useMorningEnabled() {
    return useActivatedIntegration(INTEGRATION_PROVIDERS.morning, {
        suspense: true
    });
}